// extracted by mini-css-extract-plugin
export default {"contactsBlock":"Contacts_contactsBlock__zxpHJ","contactsContainer":"Contacts_contactsContainer__eMIss","forms":"Contacts_forms__Mxzcq"};